import { render, staticRenderFns } from "./Shopping-Cart.vue?vue&type=template&id=2adf13aa&scoped=true"
import script from "./Shopping-Cart.vue?vue&type=script&lang=js"
export * from "./Shopping-Cart.vue?vue&type=script&lang=js"
import style0 from "./Shopping-Cart.vue?vue&type=style&index=0&id=2adf13aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adf13aa",
  null
  
)

export default component.exports